<span [class.active]='active'>{{ placeholder }}
</span>
<span *ngIf='active' class='clear' (click)='clear.emit(); $event.stopPropagation()'>&times;</span>
